import {
  useRecordContext,
  Button,
  useDataProvider,
  useNotify,
  useRefresh,
  TextInput,
  DateInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
} from "react-admin";
import DoneIcon from "@mui/icons-material/Done";
import { DoctoralRankingStatus } from "utils/constants";
import { doctoralRequests } from "api/doctoralApi";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import FormModal from "server/components/Modals/FormModal";

const DoctoralApproveRankingButton = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();

  const status = record?.status;

  if (!record || status !== DoctoralRankingStatus.Draft) {
    return null;
  }

  // No try/catch: FormModal notifies on error and stays open.
  const approveDraft = async ({ seatOrders }) => {
    await dataProvider.customRequest(doctoralRequests.approveCampaignRanking(record.id), { seatOrders }, "POST");
    notify("Успешно одобрено класиране", { type: "success" });
    refresh();
  };

  const seatChoices = (record.seatRankings ?? []).map(s => ({
    id: s.doctoralSeatId,
    name: s.doctoralProgramNameBg
      ? `${s.doctoralProgramNameBg}${s.doctoralDisciplineNameBg ? ` — ${s.doctoralDisciplineNameBg}` : ""}`
      : `Място ${s.doctoralSeatId}`,
  }));

  return (
    <SecuredComponent permission={permissions.canManageDoctoralCampaignRankings}>
      <FormModal
        triggerButton={
          <Button
            label="Одобряване"
            variant="contained"
            size="medium"
          >
            <DoneIcon />
          </Button>
        }
        titleContent="Одобряване на класиране"
        onConfirm={approveDraft}
        saveTitle="Одобри"
        saveIcon={<DoneIcon />}
        closeTitle="Затвори"
        dialogSize="md"
      >
        <ArrayInput
          source="seatOrders"
          label="Заповеди"
          defaultValue={seatChoices.map(s => ({ doctoralSeatId: s.id }))}
          validate={required()}
        >
          <SimpleFormIterator
            disableAdd
            disableRemove
            disableReordering
            disableClear
            inline
            sx={{ "& .RaSimpleFormIterator-line": { paddingY: 1, paddingX: 2, marginBottom: 3 } }}
          >
            <SelectInput
              source="doctoralSeatId"
              label="Място"
              readOnly
              fullWidth
              helperText={false}
              choices={seatChoices}
              sx={{ minWidth: 350 }}
            />
            <DateInput
              source="orderDate"
              label="Дата на заповед"
              validate={required()}
              helperText={false}
            />
            <TextInput
              source="orderNumber"
              label="Номер на заповед"
              validate={required()}
              helperText={false}
            />
          </SimpleFormIterator>
        </ArrayInput>
      </FormModal>
    </SecuredComponent>
  );
};

export default DoctoralApproveRankingButton;
